import React from "react";
import TextField from '@material-ui/core/TextField';
import withStyles from "@material-ui/core/styles/withStyles";
import Button from "@material-ui/core/Button";
import {Link} from "@material-ui/core";
import {ReCAPTCHA} from "react-google-recaptcha";

const styles = theme => {
    return {
        textField: {
            width: '80%',
            marginTop: '40px',
            marginRight: '40px',
            marginLeft: '40px',
        },
        form: {
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column'
        },
        button: {
            color: '#fff',
            marginTop: '40px'
        }
    }

}

class RegisterForm extends React.Component {
    constructor() {
        super();
        this.state = {
            'email': '',
            'password': '',
            'password_confirmation': '',
            'agency_name': '',
            'phone' : ''
        }
    }

    handleChange = (e) => {
        const {name, value} = e.target;
        if (name === 'phone' && (/^[0-9+]+$/.test(value) || !value)) {
            this.setState({'phone' : value || ''})
        } else if (name !== 'phone') {
            this.setState({[name] : value})
        }

    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.onSubmit(this.state);
    }

    render() {
        const {classes} = this.props;
        return (
            <form className={classes.form}>

                <TextField
                    className={classes.textField}
                    required={true}
                    label={'Имя'}
                    variant={'outlined'}
                    name={'name'}
                    onInput={this.handleChange}
                />

                <TextField
                    className={classes.textField}
                    required={true}
                    label={'Название кабинета'}
                    variant={'outlined'}
                    name={'agency_name'}
                    onInput={this.handleChange}
                />

                <TextField
                    className={classes.textField}
                    value={this.state['phone']}
                    required={true}
                    name={'phone'}
                    label={'Номер телефона'}
                    placeholder={'+3 8099 999 99 99'}
                    variant={'outlined'}
                    onInput={this.handleChange}
                />
                <TextField
                    className={classes.textField}
                    required={true}
                    label={'Email'}
                    variant={'outlined'}
                    type={'email'}
                    name={'email'}
                    onInput={this.handleChange}
                />


                <TextField
                    className={this.props.classes.textField}
                    required={true}
                    label={'пароль'}
                    variant={'outlined'}
                    type={'password'}
                    placeholder={'Должен содержать не менее 6 символов без пробелов'}
                    name={'password'}
                    onInput={this.handleChange}
                />

                <TextField
                    className={this.props.classes.textField}
                    required={true}
                    label={'Повторите пароль'}
                    variant={'outlined'}
                    type={'password'}
                    name={'password_confirmation'}
                    onInput={this.handleChange}

                />
                <ReCAPTCHA sitekey={'6LfQ6NEZAAAAAPCvFZ9g8tW-yDSyuXDBMxxgDw2F'} />

                <Button variant={'contained'} color={'primary'} className={classes.button} onClick={this.handleSubmit}>
                    Подтвердить
                </Button>


            </form>
        );
    }
}

export default withStyles(styles)(RegisterForm)